import React, { useEffect } from "react";
import { type BillingInfo, type PaymentFormData } from "../../types";
import InputField from "components/forms/InputField/InputField";
import DropdownField from "components/forms/DropdownField";
import styles from "./BillingSection.module.scss";
import type { FormikProps } from "formik";

interface BillingSectionProps {
  billingInfo: BillingInfo;
  formik: FormikProps<PaymentFormData>;
  stateOptions: { text: string; value: string }[];
}

const countryOptions = [{ text: "United States", value: "United States" }];

const BillingSection = ({ billingInfo, formik, stateOptions }: BillingSectionProps) => {
  const { country, streetAddress, city, state, zipCode } = billingInfo;

  useEffect(() => {
    if (!state && stateOptions.length > 0) {
      formik.setFieldValue("billingInfo.state", stateOptions[0].value);
    }
  }, [state, stateOptions, formik]);

  return (
    <>
      <DropdownField
        {...formik}
        propertyName={"billingInfo.country"}
        label={"Country/Region"}
        value={country}
        options={countryOptions}
        markAsRequired
        disabled
      />

      <InputField
        {...formik}
        propertyName={"billingInfo.streetAddress"}
        label={"Street Address"}
        placeholder={"Enter Street Address"}
        value={streetAddress}
        markAsRequired
      />

      <div className={styles.addressFields}>
        <div className={styles.field}>
          <InputField
            {...formik}
            propertyName={"billingInfo.city"}
            label={"City"}
            placeholder={"Enter City"}
            value={city}
            markAsRequired
            errorPosition={"bottom"}
          />
        </div>

        <div className={styles.field}>
          <DropdownField
            {...formik}
            propertyName={"billingInfo.state"}
            label={"State"}
            placeholder={"Select a State"}
            value={state}
            options={stateOptions}
            markAsRequired
            errorPosition={"bottom"}
            search
          />
        </div>

        <div className={styles.field}>
          <InputField
            {...formik}
            propertyName={"billingInfo.zipCode"}
            label={"Zip Code"}
            placeholder={"Enter Zip Code"}
            value={zipCode}
            markAsRequired
            errorPosition={"bottom"}
          />
        </div>
      </div>
    </>
  );
};

export default BillingSection;
